import {
  PlanDescription,
  PlanDetailWrapper,
  PlanDetailsWrapper,
  PlanName,
  PlanPrice,
  PlanType,
  UpgradePlanButton,
  Wrapper,
} from "./style";
import routeConstant from "../../utils/routeConstant";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { activeSubscriptionSelector } from "../../store/payment/selector";
import { PaymentSagaActions } from "../../store/payment/sagas";

const PlanSection = () => {
  const dispatch = useDispatch();
  const activePlan = useSelector(activeSubscriptionSelector);
  const navigate = useNavigate();
  // Functions
  const handleRedirect = () => {
    navigate(`${routeConstant.subscription}`);
  };

  useEffect(() => {
    dispatch(PaymentSagaActions.getActiveSubscription());
  }, [dispatch]);

  return (
    <>
      {activePlan && Object.keys(activePlan?.activePlanDetails)?.length > 0 && (
        <Wrapper>
          <PlanType>Active Plan</PlanType>
          <PlanDetailsWrapper>
            <PlanDetailWrapper>
              <PlanName>{activePlan?.activePlanDetails?.name}</PlanName>
              <PlanDescription>
                {activePlan?.activePlanDetails?.description}
              </PlanDescription>
              {activePlan?.activePlanDetails?.amount !== 0 &&
                activePlan?.activePlanDetails?.amount && (
                  <PlanPrice weight={400} size="0.875rem">
                    <PlanPrice weight={700} size="1rem">
                      ${activePlan?.activePlanDetails?.amount}
                    </PlanPrice>
                    / month
                  </PlanPrice>
                )}
            </PlanDetailWrapper>
            <UpgradePlanButton onClick={handleRedirect}>
              Upgrade Plan
            </UpgradePlanButton>
          </PlanDetailsWrapper>
        </Wrapper>
      )}
    </>
  );
};

export default PlanSection;
